module.exports = __webpack_public_path__ + "img/250460827_2025_2-4.ebcbccf7.png";